import { signOut, signInWithRedirect } from "aws-amplify/auth";
import { clearCache } from "./cache.service";

export async function logoutAndRedirect() {
  try {
    await signOut({ global: true });
  } catch (signOutError) {
    console.error("Sign out failed:", signOutError?.message || signOutError);
  }

  try {
    await clearCache();
  } catch (cacheError) {
    console.error("Cache clear failed:", cacheError?.message || cacheError);
  }

  localStorage.clear();

  if (process.env.REACT_APP_SSO_LOGOUT) {
    window.location.assign(process.env.REACT_APP_SSO_LOGOUT);
    return;
  }

  await signInWithRedirect();
}
